import React from 'react'
import Header from '../_components/common/Header'
import Index from '../_components/OurPlans/Index'

const OurPlans = () => {
  return (
    <div className='page-main'>
        <Header name = {["Our Plans"]} />
        <Index />

    </div>
  )
}

export default OurPlans